// billing strings (fr).
// Machine-drafted — review with a native speaker before launch.
const billing = {
	billing: {
		// Billing overview
		billingTitle: 'Facturation',
		backToBilling: 'Retour à la facturation',
		backToBillingLower: 'retour à la facturation',
		grabExclusiveDeals: 'Profitez de nos offres exclusives %{type}',
		lifetime: 'À vie',
		monthly: 'Mensuel',
		insteadOfRegular: 'Au lieu de notre tarif habituel',
		regularPriceStrike: '9 $ par utilisateur/par mois',
		pricingSuffix: 'tarif,',
		limitedTimeOffer: 'nous proposons une offre à vie en un seul paiement pour une durée limitée.',
		annual: 'Annuel',
		twentyPercentOff: '20 % de réduction',

		// Plan detail
		noPlanSelected: 'Aucun forfait sélectionné',
		trialPeriod: 'Période d’essai',
		upcomingInvoice: 'Votre prochaine facture. Vous serez débité après %{days}',
		days14: '14 jours.',
		days30: '30 jours.',
		days365: '365 jours.',
		notSubscribed: 'Cher utilisateur, vous n’êtes abonné à aucun forfait. Veuillez mettre à niveau votre forfait.',
		planLineItem: '%{members} utilisateur x Forfait %{plan} (à %{price} $)',
		noWord: 'Aucun',
		total: 'Total',
		upgradePlan: 'Mettre à niveau le forfait',
		managePayment: 'Gérer le paiement',
		cancelSubscription: 'Annuler l’abonnement',

		// Cancel subscription confirmation
		areYouSure: 'Êtes-vous sûr ?',
		cancelSubConfirm: 'Voulez-vous annuler votre abonnement actuel ?',
		no: 'Non',
		yes: 'Oui',

		// Plan limits
		limits: 'Limites',
		workspace: 'Espace de travail',
		teamMembers: 'Membres de l’équipe',
		uniqueRecipients: 'Destinataires uniques',
		cards: 'Cartes',
		aiCredits: 'Crédits IA',
		emailAccountsLabel: 'Comptes e-mail',
		of: 'sur',
		used: 'utilisés',
		ofUnlimitedUsed: 'sur illimité utilisés',
		willBeRefreshed: 'sera renouvelé le %{date}',
		lifetimeSubscription: 'Vous avez un abonnement à vie.',
		recipientsLimitTooltip: 'Limite de destinataires %{expiry}',
		cardsLimitTooltip: 'Limite de cartes %{expiry}',
		aiCreditsLimitTooltip: 'Limite de crédits IA %{expiry}',

		// Redeem codes
		cannotRedeemMore: 'Impossible d’utiliser plus de 8 codes',
		codeAlreadyAdded: 'Code déjà ajouté',
		enterAppsumoCodeTitle: 'Saisissez le code AppSumo',
		hitPlusIcon: "Appuyez sur l’icône '+' ou sur Entrée après avoir saisi votre code",
		planUpdated: 'Forfait mis à jour !',
		redeem: 'Utiliser',
		cancel: 'Annuler',

		// Common swal titles
		successTitle: 'Succès',
		errorTitle: 'Erreur',
		oopsTitle: 'Oups',

		// Receipts / data table
		receipts: 'Reçus',
		paymentHistory: 'Votre historique de paiement pour votre abonnement sur CardClan',
		view: 'Voir',
		id: 'Id',
		plan: 'Forfait',
		price: 'Prix',
		totalCards: 'Total des cartes',
		date: 'Date',

		// Change plan
		changePlan: 'Changer de forfait',

		// Email accounts list
		emailsTitle: 'E-mails',
		connectEmailAccount: 'Connecter un compte e-mail',
		connectEmailAccountBtn: 'Connecter un compte e-mail',
		needHelpConnecting: 'Besoin d’aide pour connecter le compte e-mail ?',
		successfullyDeleted: 'Supprimé avec succès',
		deleteAccountError: 'Une erreur s’est produite lors de la suppression de votre compte. Veuillez réessayer !',
		noEmailAccountLimit: 'Votre forfait ne permet pas de créer des comptes e-mail. Mettez à niveau votre forfait pour ajouter des comptes e-mail.',
		noEmailAccounts: 'Aucun compte e-mail connecté pour le moment.',
		getStartedConnecting: 'Commencez par connecter un nouveau compte e-mail.',
		howToSetupSmtp: 'Comment configurer un compte d’expéditeur SMTP ?',

		// Email account modal
		editEmailAddress: 'Modifier l’adresse e-mail',
		addEmailAddress: 'Ajouter une adresse e-mail',
		fromName: 'Nom de l’expéditeur',
		userName: 'nom d’utilisateur',
		smtpHost: 'Hôte SMTP',
		differentReplyTo: 'Définir une adresse de réponse différente',
		fromEmail: 'E-mail de l’expéditeur',
		passwordLabel: 'mot de passe',
		smtpPort: 'Port SMTP',
		ssl: 'SSL',
		tls: 'TLS',
		replyTo: 'Répondre à',
		updateSettings: 'Mettre à jour les paramètres',
		saveSettings: 'Enregistrer les paramètres',
		accountUpdated: 'Votre compte e-mail a été mis à jour avec succès',
		accountConnected: 'Votre compte e-mail a été connecté avec succès',
		minChars: 'doit contenir au moins 2 caractères ',
		maxChars: 'doit contenir au maximum 25 caractères ',
		invalidEmail: 'Format d’e-mail invalide',
		emailRequired: 'L’e-mail est requis',
		port25Blocked:
			'Les requêtes e-mail via le port 25 sont bloquées par les serveurs de l’hôte. Il est conseillé d’utiliser un autre port pour cette opération.',

		// Email account table
		name: 'Nom',
		status: 'Statut',
		action: 'Action',
		active: 'Actif',
		edit: 'Modifier',
		deleteWord: 'Supprimer',

		// White label
		whiteLabel: 'Marque blanche',
		noCustomDomain: 'Vous n’avez pas encore configuré votre domaine personnalisé.',
		brandPresets: 'Préréglages de marque',
		brandingDescription: 'Voici votre image de marque qui apparaîtra sur toute la plateforme',
		appTitle: 'Titre de l’application',
		appTitlePlaceholder: 'ex. mon-app',
		brandColorsTitle: 'Couleurs de marque',
		reset: 'Réinitialiser',
		save: 'Enregistrer',
		clickSaveToUpdate: 'Veuillez cliquer sur le bouton Enregistrer pour mettre à jour vos modifications.',
		invalidFile: 'Fichier invalide !',
		uploadLogo: 'Téléverser le logo',
		uploadImage: 'Téléverser l’image',
		uploading: 'Téléversement...',

		// Logo / color labels
		darkLogo: 'Logo foncé',
		lightLogo: 'Logo clair',
		favicon: 'Favicon',
		accentColor: 'Couleur d’accent',
		backgroundColor: 'Couleur de fond',
		sidebarColor: 'Couleur de la barre latérale',

		// Workspace domain
		workspaceDomain: 'Domaine de l’espace de travail',
		loading: 'Chargement...',
		domainsUsed: '%{used} sur %{limit} domaines d’espace de travail utilisés',
		customDomainFor: 'Domaine personnalisé pour "%{name}"',
		currentWorkspaceFallback: 'Espace de travail actuel',
		assignDomainDesc: 'Attribuez un domaine personnalisé à cet espace de travail pour des liens de cartes à votre marque',
		domainName: 'Nom de domaine',
		saveDomain: 'Enregistrer le domaine',
		checkDns: 'Vérifier le DNS',
		cnameInstructions:
			'Ajoutez l’enregistrement CNAME suivant dans les paramètres de votre DNS. Votre webmestre ou administrateur de serveur peut vous aider à le configurer.',
		typeCol: 'Type',
		keyCol: 'Clé',
		valueCol: 'Valeur',
		copy: 'copier',
		invalidDomain: 'Domaine invalide. N’incluez pas le protocole (http/https)',
		domainRequired: 'Le domaine est requis',
		domainCreated: 'Domaine de l’espace de travail créé. Veuillez configurer votre DNS et vérifier.',
		failedCreateDomain: 'Échec de la création du domaine',
		domainVerified: 'Domaine vérifié avec succès ! Il est maintenant actif.',
		verificationFailed: 'Échec de la vérification',
		dnsVerificationFailed: 'La vérification DNS a échoué. Assurez-vous que le CNAME pointe vers ssl.cardclan.me',
		deletedTitle: 'Supprimé',
		domainRemoved: 'Le domaine de l’espace de travail a été supprimé.',
		failedDeleteDomain: 'Échec de la suppression du domaine',

		// Workspace domain add-on
		addonTitle: 'Module complémentaire de domaines personnalisés d’espace de travail',
		addonDesc:
			'Attribuez des domaines personnalisés uniques à des espaces de travail individuels. Chaque espace de travail peut avoir son propre domaine de marque pour les liens de cartes.',
		addonHeading: 'Domaines personnalisés pour les espaces de travail',
		addonSubDesc: 'Chaque unité vous donne 3 domaines personnalisés d’espace de travail. Ajustez la quantité pour en obtenir plus.',
		perMonth: '/mois',
		workspaceDomainsCount: '%{count} domaines d’espace de travail',
		featureDomainsPerUnit: '3 domaines personnalisés d’espace de travail par unité',
		featureDnsVerification: 'Vérification DNS avec CNAME',
		featureAdjustableQty: 'Quantité ajustable au moment du paiement',
		purchaseAddon: 'Acheter le module complémentaire',

		// Video card settings
		videoCardSettingsPageTitle: 'Paramètres des cartes vidéo | CardClan',
		videoCards: 'Cartes vidéo',
		videoCardsDesc: 'Contrôlez si les cartes vidéo sont disponibles pour les membres de cet espace de travail.',
		enableVideoCards: 'Activer les cartes vidéo',
		enableVideoCardsDesc:
			'Lorsqu’elles sont désactivées, les membres de l’espace de travail ne peuvent pas créer de cartes vidéo ni accéder à la section des cartes vidéo.',
		saved: 'Enregistré !',
		failedSave: 'Échec de l’enregistrement',
		enabled: 'Activé',
		disabled: 'Désactivé',

		// Integration key
		generateIntegrationKey: 'Générer une clé d’intégration',
		integrationKeyDesc: 'Utilisez cette clé pour vous connecter à des plateformes d’automatisation externes comme Pabbly Connect',
		integrationKeyCreated: 'La clé d’intégration a été créée avec succès.',
		usageInstructions: 'Instructions d’utilisation :',
		usageStep1: 'Copiez cette clé dans votre presse-papiers',
		usageStep2: 'Dans Pabbly Connect, créez une nouvelle connexion',
		usageStep3: 'Collez cette clé comme jeton Bearer ou clé API',
		integrationKeyExists: 'La clé d’intégration existe déjà',
		integrationKeyExistsDesc:
			'Vous avez déjà une clé d’intégration pour une autre plateforme. Vous ne pouvez avoir qu’une seule clé d’intégration par compte.',
		integrationKeyGenerated: 'Clé d’intégration générée avec succès !',
		failedGenerateIntegrationKey: 'Échec de la génération de la clé d’intégration',
		integrationKeyCopied: 'Clé d’intégration copiée avec succès',

		// Zapier key
		generateZapierKey: 'Générer une clé Zapier',
		generateZapierKeyBtn: 'Générer une clé Zapier',
		zapierKeyDesc: 'Utilisez cette clé dans votre application Zapier pour l’authentification',
		zapierKeyCreated: 'La clé Zapier a été créée avec succès.',
		keyCopied: 'Clé %{title} copiée avec succès',

		// Preview card
		previewCard: 'Aperçu de la carte',
		previewCardDesc: 'Personnalisez l’apparence de votre carte dans un e-mail et lorsqu’on l’ouvre.',
		chooseCardBackground: 'Choisir l’arrière-plan de la carte',
		background: 'Arrière-plan',
		toggleConfetti: 'Activer les confettis',
		addCompanyLogo: 'Ajouter le logo de l’entreprise',
		logoDimensionNote: '* pour un affichage optimal, les dimensions du logo de l’entreprise doivent être de 400 x 100',
		viewCardButtonDesign: 'Conception du bouton « Voir la carte » de l’e-mail',
		preview: 'Aperçu',
		buttonText: 'Texte du bouton',
		buttonRounded: 'Bouton arrondi',
		buttonColor: 'Couleur du bouton',
		saveChanges: 'Enregistrer les modifications',
		viewChanges: 'Voir les modifications',
		changesSaved: 'Modifications enregistrées avec succès.',
		previewGreeting: 'Bonjour nom, %{name} a créé une carte numérique',
		previewFooter: 'Votre boîte de réception vient de recevoir une livraison spéciale. Consultez votre carte en ligne.',

		// Settings navigation
		navYourProfile: 'Votre profil',
		navBilling: 'Facturation',
		navManageWorkspaces: 'Gérer les espaces de travail',
		navBasicSettings: 'Paramètres de base',
		navTeamMembers: 'Membres de l’équipe',
		navEmailAccounts: 'Comptes e-mail',
		navCustomDomainSettings: 'Paramètres de domaine personnalisé',
		navDashboard: 'Tableau de bord',
		navMyCards: 'Mes cartes',
		navSettings: 'Paramètres',
		accountSettings: 'Paramètres du compte',
		whiteLabelSettingsSection: 'Paramètres de marque blanche',
	},
};
export default billing;
